module.exports = __webpack_public_path__ + "img/59.40cddb96.png";